import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";

function AllPage() {
  const params = useParams();
  const [pages, setPages] = useState([]);
  const [webSitePublisherData, setWebSitePublisherData] = useState({});
  const sitePublisherID = params.id;

  useEffect(() => {
    getAllPages();
    getWebSitePublisherData();
  }, []);

  const getWebSitePublisherData = async () => {
    setWebSitePublisherData(
      await sendRequestGetWebSitePublisherData(sitePublisherID)
    );
  };

  const sendRequestGetWebSitePublisherData = async (sitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const getAllPages = async () => {
    const resultSendRequestGetAllPages = await sendRequestGetAllPages();
    setPages(resultSendRequestGetAllPages.data);
  };

  const deletePage = async (pageID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    if (await sendRequestDeletePage(pageID)) {
      await getAllPages();
    }
  };

  const sendRequestDeletePage = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/manage/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const generatePagesTable = (pages) => {
    return pages.map((page, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(page.pag_id)}</td>
          <td>{helpersNumbers.toPersianNum(page.pag_priority)}</td>
          <td>
            {page.pag_title}
            {page.pag_pattern_url.includes("/@s") ? (
              <span className="badge badge-success">چند صفحه ای</span>
            ) : (
              <></>
            )}
          </td>
          <td>
            <div dir="ltr" className="text-left">
              {page.pag_pattern_url}
            </div>
          </td>
          <td>
            <div dir="ltr" className="text-center">
              {page.pag_active ? (
                <span className="badge badge-success">فعال</span>
              ) : (
                <span className="badge badge-danger">غیرفعال</span>
              )}
            </div>
          </td>
          <td>
            <a href={page.pag_link} target="_blank" className="btn btn-info">
              <i className="fa fa-eye"></i>
            </a>
          </td>
          <td>
            <span className="pl-2">
              <Link
                className="btn btn-info"
                to={`/manage/position/all/${page.pag_id}`}
              >
                <span className="pl-2">
                  <i class="fas fa-file-code"></i>
                </span>
                <span>نمایش جایگاه ها</span>
              </Link>
            </span>

            <span className="pl-2">
              <Link
                to={`/manage/page/edit/${page.pag_id}`}
                className="btn btn-success  "
              >
                <i className="fa fa-edit"></i>
              </Link>
            </span>

            <span className="pl-2">
              <span
                className="btn btn-danger"
                onClick={(e) => deletePage(page.pag_id)}
              >
                <i className="fa fa-trash"></i>
              </span>
            </span>
          </td>
        </tr>
      );
    });
  };

  const sendRequestGetAllPages = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultSendRequestGetAllPages;

    try {
      resultSendRequestGetAllPages = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/page/manage/web-site-publisher/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultSendRequestGetAllPages.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span>صفحات سایت</span>
                  <span className="pr-2">
                    <a
                      target="_blank"
                      className="text-white"
                      href={webSitePublisherData?.url}
                    >
                      {webSitePublisherData?.url?.replace("http://", "")}
                    </a>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-2 d-flex justify-content-between">
                <Link
                  className="text-white"
                  to={`/manage/page/add/${sitePublisherID}`}
                >
                  <div className="btn btn-success">
                    <span className="pl-2">
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span>
                      <span className="text-white">
                        اضافه کردن صفحه به سایت{" "}
                        {webSitePublisherData?.url?.replace("http://", "")}
                      </span>
                    </span>
                  </div>
                </Link>

                <Link
                  className="text-white"
                  to={`/manage/publishers/edit/${sitePublisherID}`}
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              <div className="table-responsive ">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره</td>
                      <td>اولویت</td>
                      <td>عنوان</td>
                      <td>الگوی آدرس</td>
                      <td>وضعیت</td>
                      <td>لینک</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {pages.length != 0 ? generatePagesTable(pages) : <></>}
                  </tbody>
                </table>
              </div>
              <div className="pt-2">
                <Link
                  className="text-white"
                  to={`/manage/position/all-independent/${sitePublisherID}`}
                >
                  <div className="btn btn-primary">
                    <span className="pl-2">
                      <i
                        className="fa fa-eye text-white"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span>
                      <span className="text-white">نمایش جایگاه های مستقل</span>
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPage;
